export default class VideoCategoryHeader {
	constructor(el) {
		this.el = el;
		this.swiper = this.el.querySelector('.video-category-swiper');
		this.categories = this.el.querySelectorAll('.video-category');

		this.initSwiper();
		this.initCategoryHeader();
	}

	initSwiper() {
		this.swiperInstance = new Swiper(this.swiper, {
			navigation: {
				nextEl: '.swiper-button-next--2',
				prevEl: '.swiper-button-prev--2',
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			direction: 'horizontal',
			loop: false,
			watchOverflow: true,
			autoplay: false,
			slidesPerView: 'auto',
			shortSwipes: false,
		});
	}

	initCategoryHeader() {
		this.categories.forEach((category, index) => {
			category.addEventListener('click', (e) => {
				e.preventDefault();

				const event = new CustomEvent('load-category', {
					detail: { category: category.dataset.category },
				});

				document.dispatchEvent(event);

				this.categories.forEach((item) => {
					item.classList.remove('video-category--active');
				});

				e.target.parentNode.classList.add('video-category--active');

				this.swiperInstance.slideTo(index);
			});
		});
	}
}
